import { AuthContext } from 'context/AuthContext';
import { HeadquarterContext } from 'context/HeadquarterContext';
import initPendoUser from 'helpers/initPendoUser';
import { useComputedColorScheme } from '@mantine/core';
import { useContext, useEffect } from 'react';

export function PendoProvider() {
  const { user } = useContext(AuthContext);
  const { location } = useContext(HeadquarterContext);
  const colorScheme = useComputedColorScheme('light');

  useEffect(() => {
    if (!user || !location) {
      return;
    }

    initPendoUser(user, location.id);
  }, [location, user]);

  useEffect(() => {
    document.body.classList.toggle('pendo-dark', colorScheme === 'dark');
    return () => document.body.classList.remove('pendo-dark');
  }, [colorScheme]);
}
